import { genreOptions, regionOptions, sortOptions, yearOptions, type SortValue } from "@/mocks/titles";

interface FilterPanelProps {
  genre: string;
  region: string;
  year: string;
  sort: SortValue;
  onGenre: (value: string) => void;
  onRegion: (value: string) => void;
  onYear: (value: string) => void;
  onSort: (value: SortValue) => void;
  onReset: () => void;
  layout?: "vertical" | "horizontal";
}

const groups = [
  { key: "genre", label: "题材" },
  { key: "region", label: "地区" },
  { key: "year", label: "年份" },
] as const;

export default function FilterPanel({
  genre,
  region,
  year,
  sort,
  onGenre,
  onRegion,
  onYear,
  onSort,
  onReset,
  layout = "vertical",
}: FilterPanelProps) {
  const values: Record<string, string> = { genre, region, year };
  const optionsMap: Record<string, string[]> = {
    genre: genreOptions,
    region: regionOptions,
    year: yearOptions,
  };
  const handlers: Record<string, (value: string) => void> = {
    genre: onGenre,
    region: onRegion,
    year: onYear,
  };

  return (
    <div className={layout === "vertical" ? "" : "space-y-1"}>
      {groups.map((group) => (
        <div key={group.key} className="py-3 border-b border-background-200 last:border-b-0">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-foreground-500">{group.label}</span>
            {values[group.key] !== optionsMap[group.key][0] && (
              <button
                type="button"
                onClick={() => handlers[group.key](optionsMap[group.key][0])}
                className="text-[11px] text-foreground-400 hover:text-primary-700 cursor-pointer"
              >
                清除
              </button>
            )}
          </div>
          <div className="flex flex-wrap gap-1.5">
            {optionsMap[group.key].map((option) => (
              <button
                key={option}
                type="button"
                onClick={() => handlers[group.key](option)}
                className={`px-2.5 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap ${
                  values[group.key] === option
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
                }`}
              >
                {option.replace("全部", "").replace("2022及更早", "≤2022") || "全部"}
              </button>
            ))}
          </div>
        </div>
      ))}
      <div className="py-3">
        <span className="text-xs text-foreground-500 block mb-2">排序方式</span>
        <div className="flex flex-wrap gap-1.5">
          {sortOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onSort(option.value)}
              className={`px-2.5 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap ${
                sort === option.value
                  ? "bg-accent-500 text-primary-950"
                  : "bg-background-50 text-foreground-700 hover:bg-accent-50"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
      <button
        type="button"
        onClick={onReset}
        className="mt-2 w-full h-9 rounded-md border border-background-300 text-xs text-foreground-600 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
      >
        重置全部筛选
      </button>
    </div>
  );
}